@if (chartId() || downloadAllowed()) {
  <div class="chart-ribbon">
    @if (downloadAllowed()) {
      <p-menu #downloadmenu [model]="downloadMenuItems" [popup]="true" appendTo="body" baseZIndex="99999" />
      <button pButton outlined="true" (click)="downloadmenu.toggle($event)">
        <i class="fa-solid fa-download"></i>
      </button>
    }
    @if (chartId(); as id) {
      <cosmos-chart-options-button [chartId]="id" (configChange)="onChartOptionsChange($event)" />
    }
  </div>
}

<cosmos-chart-legend [items]="legendItems" (toggle)="onLegendToggle($event)" />

<div class="chart-wrapper">
  <canvas #myChart [id]="dataObject()?._id" baseChart
      [data]="chartData"
      [options]="chartOptions"
      [legend]="false"
      [plugins]="chartPlugins"
      [type]="chartType">
  </canvas>
</div>
